import * as React from 'react';
import { formatNumber } from 'helpers/number';

export const FormattedNumber = ({ value }: { value: number | null }) => {
    const number = React.useMemo(() => (value ? formatNumber(value) : '-'), [value]);

    return <>{number}</>;
};
